/**
 * Effects
 * 
 * Extends the tenant system's limited shadow/effect tokens.
 * Aligned with Figma Design System 2026 elevation and blur scales.
 * For tenant-specific shadows, use theme.decorations.boxShadow
 * 
 * @see https://www.figma.com/design/LYeg7o8lYMFZD4oPJnGTwn/Design-System-2026
 */
export const effects = {
  /**
   * Elevation (Shadows)
   * Matches Figma elevation/100, elevation/200, elevation/300, elevation/500
   */
  elevation: {
    /** Elevation 100 - Subtle shadow for cards */
    100: '0px 1px 8px rgba(0, 0, 0, 0.08)',
    /** Elevation 200 - Medium shadow for elevated cards */
    200: '0px 2px 12px rgba(0, 0, 0, 0.12)',
    /** Elevation 300 - Pronounced shadow for modals */
    300: '0px 4px 16px rgba(0, 0, 0, 0.16)',
    /** Elevation 500 - Heavy shadow for overlays */
    500: '0px 8px 24px rgba(0, 0, 0, 0.24)',
  },
  
  /**
   * Legacy shadow names (for backward compatibility)
   * @deprecated Use elevation.{100|200|300|500} instead
   */
  shadows: {
    /** @deprecated Use elevation.100 */
    light: '0px 1px 8px rgba(0, 0, 0, 0.08)',
    /** @deprecated Use elevation.200 */
    medium: '0px 2px 12px rgba(0, 0, 0, 0.12)',
  },
  
  /**
   * Blur Effects
   * Matches Figma blur/100, blur/200
   */
  blur: {
    /** Blur 100 - Light blur for subtle effects */
    100: 'blur(2px)',
    /** Blur 200 - Medium blur for glass effects */
    200: 'blur(4px)',
  },
  
  /**
   * Legacy backdrop filter names (for backward compatibility)
   * @deprecated Use blur.{100|200} instead
   */
  backdropFilters: {
    /** @deprecated Use blur.100 */
    light: 'blur(2px)',
    /** @deprecated Use blur.200 */
    medium: 'blur(4px)',
  },
} as const;

export type Effects = typeof effects;
